var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar',{key:_vm.$route.fullPath}),_c('div',{staticClass:"container"},[_c('router-view'),_c('loader')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }